import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-air-pipe-line',
  templateUrl: './air-pipe-line.component.html',
  styleUrls: ['./air-pipe-line.component.scss']
})
export class AirPipeLineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
